<template>
  <div class="top-wrapper">
    <div class="header-container">
      <div class="header-section">
        <div class="left-section">
          <div class="logo-view">
            <span style="font-size: 24px; color: #fff">{{ platformName }}</span>
          </div>
        </div>
        <div class="right-section">
          <div style="margin-right: 10px">
            <!-- <span>机构选择：</span> -->
            <el-cascader
              v-model="organizationCode"
              :options="organizationData"
              :show-all-levels="false"
              size="small"
              style="width: 180px"
              filterable
              :props="{
                value: 'organizationCode',
                label: 'organizationName',
                children: 'children',
                checkStrictly: true,
              }"
              @change="organizationChange"
            ></el-cascader>
          </div>
          <el-popover
            placement="bottom"
            width="0"
            trigger="click"
            v-model="popoverSyns"
          >
            <div class="infoEdit" slot="reference">
              <el-avatar
                size="medium"
                :src="require('@/assets/images/userimg.png')"
              ></el-avatar>
              <span class="username">{{ commonData.USERNAME }}</span>
            </div>
            <div class="menu-list">
              <div class="menu" @click="clickLogout" style="cursor: pointer">
                退出系统
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiSystem from "@/services/api/api-system";
import CommonData from "@/services/model/common-data";
export default {
  data() {
    return {
      apiSystem: new ApiSystem(this),
      commonData: new CommonData(this),
      visibleSso: false,
      popoverSyns: false,
      currentAccountIndex: 0,
      sysList: [],
      organizationData: [],
      organizationCode: "",
      selectCode: "",
      platformName: "",
    };
  },
  mounted() {
    this.findTitle();
    this.selectCode = this.$localStorage.get("organizationCode");
    this.organizationCode = this.$localStorage.get("organizationCode");
    this.getOrganization();
    // if (this.selectCode) {
    //   this.selectByOrganizationCode();
    // }
  },
  methods: {
    findTitle() {
      let orgMsg = this.$localStorage.get("organizationMsg");
      console.log("orgMsg", orgMsg);
      if (orgMsg) {
        if (orgMsg.organizationParam) {
          if (orgMsg.organizationParam.param) {
            let param = JSON.parse(orgMsg.organizationParam.param);
            this.platformName = param.homePageTitle;
            window.document.title = param.homePageTitle;
          } else {
            this.platformName = "智慧大数据综合管理操作平台";
            window.document.title =
              "CPS数字化农业产业园区信物融合综合管理操作系统";
          }
        } else {
          this.platformName = "智慧大数据综合管理操作平台";
          window.document.title =
            "CPS数字化农业产业园区信物融合综合管理操作系统";
        }
      } else {
        this.platformName = "智慧大数据综合管理操作平台";
        window.document.title = "CPS数字化农业产业园区信物融合综合管理操作系统";
      }
    },
    onSelectChange() {},
    getOrganization() {
      this.apiSystem.getOrganization().then((res) => {
        if (res.code == 200) {
          let listData = [];
          res.data.map((item) => {
            let newItem = {
              organizationCode: item.organizationCode,
              organizationName: item.organizationName,
              children: [],
            };
            if (item.children) {
              item.children.map((list) => {
                let newch = {
                  organizationCode: list.organizationCode,
                  organizationName: list.organizationName,
                };
                newItem.children.push(newch);
              });
            }
            listData.push(newItem);
          });
          this.organizationData = listData;
          this.selectCode = this.$localStorage.get("organizationCode");
          if (!this.selectCode) {
            this.$localStorage.set(
              "organizationCode",
              listData[0].organizationCode
            );
            this.organizationCode = this.$localStorage.get("organizationCode");
            this.selectCode = this.$localStorage.get("organizationCode");
            this.selectByOrganizationCode();
          }
        }
      });
    },
    //机构变化回调
    organizationChange() {
      //更新平台数据
      if (this.organizationCode && this.organizationCode.length != 0) {
        this.$localStorage.set(
          "organizationCode",
          this.organizationCode[this.organizationCode.length - 1]
        );
        this.selectCode = this.$localStorage.get("organizationCode");
        this.selectByOrganizationCode();
      }
    },
    selectByOrganizationCode() {
      this.apiSystem
        .selectByOrganizationCode({
          organizationCode: this.selectCode,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$localStorage.set("OPROrgMsg", res.data);
            if (res.data.longitude && res.data.longitude !== "0") {
              this.$localStorage.set("longitude", res.data.longitude);
            } else {
              this.$localStorage.set("longitude", "");
            }
            if (res.data.latitude && res.data.latitude !== "0") {
              this.$localStorage.set("latitude", res.data.latitude);
            } else {
              this.$localStorage.set("latitude", "");
            }
          }
        });
    },
    clickLogout() {
      localStorage.clear();
      window.location.href = window.backPath;
    },
    linkSso(url) {
      // window.open(url);
      if (url != "/source/main.html") {
        window.location.href = url;
      } else {
        this.$message({ type: "warning", message: "系统正在建设中..." });
      }
    },
  },
};
</script>
<style lang="scss">
.menu-list {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.top-wrapper {
  .header-container {
    .header-section {
      width: 100%;
      position: fixed;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-section {
        .logo-view {
          height: 100%;
          display: flex;
          align-items: center;
          padding-left: 24px;
        }
        .navactivebj {
          position: absolute;
          width: 179px;
          height: 15px;
          left: 12px;
          bottom: -6px;
        }
      }
      .right-section {
        display: inline-flex;
        align-items: center;
        padding-right: 20px;
        float: right;
        font-size: 14px;
        color: #ffffff;
        position: relative;
        user-select: none;
        .top-icon-view {
          font-size: 20px;
          margin-right: 20px;
          color: #ffffff;
        }
        .infoSso {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;
          outline: none;
          cursor: pointer;
          font-size: 22px;
          // margin-right: 18px;
        }
        .div-icon {
          .right-icon {
            margin: 0 18px;
            font-size: 18px;
          }
        }
        .infoEdit {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;
          outline: none;
          cursor: pointer;
          .user-avatar {
            width: 40px;
          }
          .username {
            font-size: 14px;
            margin-left: 8px;
            text-align: center;
          }
        }
      }
    }
  }
}
.sys-list {
  width: 150px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .itemSys {
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
    font-size: 12px;
    color: #333;
    .img-src {
      width: 40px;
      height: 40px;
      margin-bottom: 5px;
    }
    .name-span {
      text-align: center;
    }
  }
}
</style>
